import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import Table from "../../components/table/Table";
import ListCustomersFeature from "./ListCustomersFeature";

function ListCustomersScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListCustomersFeature(application, navigator), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const listCustomersContent = () => {
        return (
            <div>
                <LayoutContentToolbar title="Clientes"> </LayoutContentToolbar>
                <Table
                    columns={feature.columns()} rows={feature.presentedCustomers()}
                    navigateToRowObjectScreen={(params) => {
                        navigator(`/customer/${params.row.businessName}`, {state: {customer: params.row}})
                    }}
                />

            </div>
        )
    }
    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => listCustomersContent()}/>
    )
}

export default observer(ListCustomersScreen)
